// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBIKLlxkf2i5j0BGlD7dw9GN_ozQYcnCCs",
  authDomain: "million-or-bust-official.firebaseapp.com",
  projectId: "million-or-bust-official",
  storageBucket: "million-or-bust-official.firebasestorage.app",
  messagingSenderId: "374092282260",
  appId: "1:374092282260:web:1234567890abcdef"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
